import { Component } from '@theme/component';
import { onAnimationEnd } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

/**
 * Optimized Cart Icon Component
 */
class CartIcon extends Component {
  requiredRefs = ['cartBubble', 'cartBubbleText', 'cartBubbleCount'];

  get currentCartCount() {
    return parseInt(this.refs.cartBubbleCount.textContent || '0', 10);
  }

  set currentCartCount(value) {
    // Se for maior que 100, alguns temas preferem ocultar ou mostrar 99+
    this.refs.cartBubbleCount.textContent = value < 100 ? String(value) : '99+';
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
    // Pequeno delay para garantir que o DOM carregou antes de checar cache
    requestAnimationFrame(this.ensureCartBubbleIsCorrect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.onCartUpdate);
  }

  onCartUpdate = (event) => {
    const { itemCount = 0, source } = event.detail.data || {};
    // Verifica se a origem foi o formulário de produto
    const isProductForm = source === 'product-form-component';
    this.renderCartBubble(itemCount, isProductForm);
  };

  renderCartBubble = async (itemCount, comingFromProductForm, animate = true) => {
    const isEmpty = itemCount === 0;

    // 1. Atualização Visual (Classes)
    this.refs.cartBubbleCount.classList.toggle('hidden', isEmpty);
    this.refs.cartBubble.classList.toggle('visually-hidden', isEmpty);
    this.classList.toggle('header-actions__cart-icon--has-cart', !isEmpty);

    // 2. Atualização Numérica
    // Se vier do form, soma. Se vier de outra fonte (ex: gaveta), substitui.
    const finalCount = comingFromProductForm ? this.currentCartCount + itemCount : itemCount;
    this.currentCartCount = finalCount;

    // 3. Animação de entrada
    if (!isEmpty && animate) {
      this.refs.cartBubble.classList.add('cart-bubble--animating');
    }

    // 4. Salvar em Cache (SessionStorage)
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({
        value: String(finalCount),
        timestamp: Date.now()
      }));
    } catch (e) {
      // Ignora erro se cookies/storage estiverem bloqueados
    }

    // 5. Finalizar Animação
    if (!animate) return;
    await onAnimationEnd(this.refs.cartBubbleText);
    this.refs.cartBubble.classList.remove('cart-bubble--animating');
  };

  ensureCartBubbleIsCorrect = () => {
    try {
      const cached = sessionStorage.getItem('cart-count');
      if (!cached) return;

      const { value, timestamp } = JSON.parse(cached);
      
      // Validade do cache: 10 segundos para evitar dados velhos
      if (Date.now() - timestamp < 10000) {
        const count = parseInt(value, 10);
        
        // Só renderiza se o valor for válido e diferente do atual
        if (!isNaN(count) && count !== this.currentCartCount) {
          this.renderCartBubble(count, false, false);
        }
      }
    } catch (_) {
      // Falha silenciosa no parse
    }
  };
}

if (!customElements.get('cart-icon')) {
  customElements.define('cart-icon', CartIcon);
}